import { useSelector } from 'react-redux'
import classes from './SetFilterItem.module.css'
import { useEffect, useState } from 'react'
import { formatCurrencyRangeLabel, formatIncidentDateFilterLabel, selectFiltersBasedOnKey } from '../../../lib/filters'
import { formatDateLocal } from '../../../lib/script'
import { getFiltersFromLocalStorageAndRemoveSelectedFilter } from '../../../lib/filters'
import { applyWorkQFilterChangeAndFetch } from '../../../lib/hooks'

export default function SetFilterItem({item, workQ}) {
    const filters = useSelector(state => state.filter.filters)

    function removeSpecificFilter() {
        const nextFilters = { ...filters }
        delete nextFilters[item.key]

        getFiltersFromLocalStorageAndRemoveSelectedFilter(workQ?.slug, item.key, item.value)

        if (workQ?.slug) {
            applyWorkQFilterChangeAndFetch(workQ.slug, nextFilters)
        }
    }

    const [selectedOption, setSelectedOption] = useState(null)
    
    
    useEffect(() => {

        if (selectFiltersBasedOnKey(item.key)) {

            if (selectFiltersBasedOnKey(item.key).type == 'range') {

                if (item.value.includes('|')) {

                    let dateArray = item.value.split('|')
                    setSelectedOption({
                        label: `${formatDateLocal(dateArray[0])} - ${formatDateLocal(dateArray[1])}`
                    })
                } else {
                    setSelectedOption({
                        label: formatDateLocal(item.value)
                    })  
                }
                // setSelectedOption({
                //     label: item.value
                // })
            } else if (selectFiltersBasedOnKey(item.key).type == 'date_operator') {
                const label = formatIncidentDateFilterLabel(item.value)
                if (label) {
                    setSelectedOption({ label })
                }
            } else if(selectFiltersBasedOnKey(item.key).type == 'number') {
                setSelectedOption({
                    label: item.value
                })
            } else if (selectFiltersBasedOnKey(item.key).type == 'currency_range') {
                const label = formatCurrencyRangeLabel(item.value)
                if (label) {
                    setSelectedOption({ label })
                }
            } else if (selectFiltersBasedOnKey(item.key).type == 'checkbox') {
                if (item.value) {
                    setSelectedOption({
                        label: 'Yes'
                    })
                } else {
                    setSelectedOption({
                        label: 'No'
                    })
                }

            }else {
                if (item.key != 'location') {
                    if (selectFiltersBasedOnKey(item.key)?.options) {
                        let option = selectFiltersBasedOnKey(item.key).options.find(elem => elem.value == item.value)
                        setSelectedOption(option)
                    } else {
                        setSelectedOption({
                            label: item.value,
                            value: item.value
                        })
                    }
                    
                } else {                    
                    let foundInnerOption 
                    let option = selectFiltersBasedOnKey(item.key).options.find(elem => {
                        
                        if (elem.options) {
                            foundInnerOption = elem.options.find(innerOption => innerOption.value == item.value)
                        }

                        

                        return foundInnerOption
                    })

                    setSelectedOption(foundInnerOption)                
                }
                
               
            }
            
        }
    }, [item])

    const booleanFilterLabels = {
        is_case: 'Is Case',
        future_appointment: 'Future Appointment',
        assigned_task_cases: 'Assigned Task Cases',
        incident_date: 'Incident Date',
        mrq_entry_date: 'MRQ Entry Date',
        gdq_exit_date: 'GDQ Exit Date',
        fast_help_assigned_at: 'FASTHELP Assigned Date',
        days_fast_help_assigned: 'Days in FASTHELP',
        hippa: 'HIPAA',
        hiof_selected: 'HIOF Option',
    }
    const isBooleanRadioFilter = Object.prototype.hasOwnProperty.call(booleanFilterLabels, item.key)
        && item.key !== 'incident_date'
        && item.key !== 'mrq_entry_date'
        && item.key !== 'gdq_exit_date'
        && item.key !== 'fast_help_assigned_at'
        && item.key !== 'days_fast_help_assigned'
        && item.key !== 'hippa'
        && item.key !== 'hiof_selected'
    const filterLabel = workQ?.filter_groups?.find((f) => f.key === item.key)?.label
        ?? booleanFilterLabels[item.key]
        ?? item.key?.split('_').join(" ")

    return <div className={classes.individual_filter_value}>
        {/* {item.value} */}
        <span className={classes.label}>{filterLabel}</span>
        {selectedOption && <div className={classes.individual_filter_value_inner}>
            {/* {selectedOption.label} */}
            {isBooleanRadioFilter ? (Number(item.value) === 1 ? 'Yes' : 'No') : (selectedOption?.short_name ? selectedOption?.short_name : selectedOption?.label)}
            <button title="remove filter" onClick={removeSpecificFilter}>
                <i className="ti ti-x"></i>                    
            </button>
        </div>}
    </div>
}